import { AxiosService } from "./AxiosService"
export type CheckoutType = 'Subscription' | 'Token' | 'FeedSubscription'
export type Checkout = {
    transactionId: string
    currency: string
    productName?: string
    value: string
    type: CheckoutType
}
export type CheckoutResult = Checkout | 'NotFound'
export const CheckoutService = new (class {
    getCheckoutResult(userToken: string, checkoutSessionId: string): Promise<CheckoutResult> {
        return AxiosService.getAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/checkout`, userToken, { checkoutSessionId })
    }

    createSubscriptionCheckoutSession(userToken: string, priceId: string): Promise<string> {
        return AxiosService.postAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/checkout/subscription?priceId=${priceId}`, userToken)
    }

    createProductCheckoutSession(userToken: string, priceId: string): Promise<string> {
        return AxiosService.postAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/checkout/product?priceId=${priceId}`, userToken)
    }
})()


export const OrganizationCheckoutService = new (class {
    getCheckoutResult(userToken: string, checkoutSessionId: string, organizationUrl: string): Promise<CheckoutResult> {
        return AxiosService.getAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/org/${organizationUrl}/checkout`, userToken, { checkoutSessionId })
    }
})()
